<template>
  <div>
    <div class="image-container" :id="`image-container-${advanced_visual.advanced_visual_id}`">
      <img 
        :src="advanced_visual.data_url"
        :alt="`Image ${advanced_visual.name}`"
        :style="{ height: '100%', width: '100%', 'object-fit': 'contain' }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdvancedVisualPreview',
  props: {
    advanced_visual: {
      type: Object,
    }
  }
}
</script>

<style scoped>

.image-container {
  min-height: 200px;
  width: 100%;
  height: 100%;
}
</style>
